export type HoursPeriod = readonly [startMinutes: number, endMinutes: number];

const TETON_VALLEY_TIME_ZONE = "America/Boise";

const weeklyHours: Record<string, readonly HoursPeriod[]> = {
  Sun: [[660, 1290]],
  Mon: [[660, 1290]],
  Tue: [[660, 1290]],
  Wed: [[660, 1290]],
  Thu: [[660, 1440]],
  Fri: [
    [0, 570],
    [660, 1290],
  ],
  Sat: [[660, 1290]],
};

export function isRestaurantOpen(date = new Date()): boolean {
  const parts = new Intl.DateTimeFormat("en-US", {
    timeZone: TETON_VALLEY_TIME_ZONE,
    weekday: "short",
    hour: "2-digit",
    minute: "2-digit",
    hourCycle: "h23",
  }).formatToParts(date);

  const weekday = parts.find((part) => part.type === "weekday")?.value;
  const hour = Number(parts.find((part) => part.type === "hour")?.value);
  const minute = Number(parts.find((part) => part.type === "minute")?.value);

  if (!weekday || Number.isNaN(hour) || Number.isNaN(minute)) {
    return false;
  }

  const currentMinutes = hour * 60 + minute;
  return (weeklyHours[weekday] ?? []).some(
    ([startMinutes, endMinutes]) =>
      currentMinutes >= startMinutes && currentMinutes < endMinutes,
  );
}
